import { Avatar, AvatarGroup, Box, Button, Divider, IconButton, InputAdornment, Portal, Typography } from '@mui/material';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getChats, getHistoricMessages, startChat } from '../../actions/chat';
import { showChatAction } from '../../actions/chatUI';
import theme from '../../muiTheme';
import { truncate } from '../../utils/utils';
import CloseButton from '../Buttons/CloseButton';
import CustomInput from '../Form/CustomInput';
import UserAvatar from '../UserAvatar/UserAvatar';
import { FiSend, FiSearch } from "react-icons/fi";
import { searchUsers } from '../../actions/profile';
import ChatScreen from './ChatScreen';

const ChatView = () => {

    const {authData } = useSelector((state) => state.authReducer);
    const {chatNotification, showChat} = useSelector((state) => state.chatUIReducer);
    const {chats, currentPage, numberOfPages, currentChat, currentMessagesPage, numberOfMessagesPages} = useSelector((state) => state.chatReducer);
    const [currentScreen, setCurrentScreen] = useState('homeScreen');
    const dispatch = useDispatch();

    const closeChat = () => {

        dispatch(showChatAction(false));

    }

    const fetchMore = () => {

        dispatch(getChats(authData.result._id, currentPage+1));
    }

    //homeScreen

    const openChat = (id) => {

        //get chat messages (returned in chatroom object)
        dispatch(getHistoricMessages(authData.result._id, id, 1, (err, res)=>{

            console.log('chat messages response: ', res);

            if(err){

                return console.warn(err);
            }

            if(res && res.chatRoom){
                switchScreen('chatScreen');
                
            }   


        }));

        
    }

    const homeScreen = (
        <>
        
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'auto',
                    height: 'auto',
                    padding: '20px',
                    boxSizing: 'border-box',
                    background: 'white',
                    color: 'white'
                }}
            >

                <Button variant='main' onClick={e=>switchScreen('newChatScreen')} startIcon={<FiSend />}> 
                    New Message
                </Button>

            </Box>


            {
                chats.length > 0 ?


                <Box
                    sx={{
                        flex: 9,
                        overflowY: 'scroll',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        width: '100%',
                        position: 'relative',
                        marginBottom: '15px',
                    }}
                >

                    {
                        chats.map((chat)=>{

                            let filteredParticipants = chat.participants.filter(participant => participant._id !== authData.result._id); 
                            let participantsList = filteredParticipants.length > 1 ? filteredParticipants[0].name + ','+filteredParticipants[1].name : filteredParticipants[0].name;
        
                            let displayMessage = chat.messages[0] ? (chat.messages[0].creator === authData.result._id ? 'You: ': '') + (chat.messages[0].message) : 'No messages yet!'; 

                            return (
                                <Box

                                    key={'chat-'+chat._id}
                                
                                    sx={{
                                        minHeight: '100px',
                                        maxWidth: '100%',
                                        borderRadius: '0px',
                                        background: 'white',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        padding: '0px 20px',
                                        margin: '2px 0px',

                                    }}

                                    onClick={e=>openChat(chat._id)}

                                >


                                    <AvatarGroup max={2}>

                                        {
                                            filteredParticipants.map((participant, index)=>(



                                                <Avatar
                                                    key={'chat-'+chat._id+'-participant-'+participant._id}
                                                    alt={participant.name}
                                                    src={participant.profileImage}
                                                    // sx={{
                                                    //     width: '60px',
                                                    //     height: '60px',
                                                    //     left: index > 0 ? '-35px': '0px',
                                                    //     borderWidth: '4px'
                                                    // }}
                                                />
                                            ))
                                        }
                                    </AvatarGroup>
                                    

                                    
                                    
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            justifyContent: 'center',
                                            marginLeft: '10px'
                                        }}
                                    > 

                                        

                                        <Typography variant='body1' sx={{fontWeight: '600', display: 'inline-block'}}> 
                                            {chat.name ? chat.name : truncate(participantsList, 30)} 
                                        </Typography> 
                                        
                                        

                                        <Typography variant='body2' sx={{marginTop: '3px', color: theme.palette.gray}}>
                                            {displayMessage}
                                        </Typography>

                                    </Box>
                                    

                                </Box>
                            );
                        })
                    }

                    {
                        (currentPage < numberOfPages) &&

                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                height: '200px',
                                padding: '20px',
                                boxSizing: 'border-box',
                                background: 'white',
                                color: 'white'
                            }}
                        >

                            <Button variant='main' onClick={fetchMore}> 
                                Load more
                            </Button>

                        </Box>
                    }
                    

                </Box>

                :

                <Box
                    sx={{
                        flex: 9,
                        overflowY: 'scroll',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        position: 'relative',
                        minHeight: '150px'
                    }}
                >

                    <Typography variant='body1'>
                        No Notifications yet!
                    </Typography>

                </Box>

            }

        </>
    );


    //new chat screen + state
    const [searchValue, setSearchValue] = useState(''); 
    const [searchResults, setSearchResults] = useState([]);
    const [selectedParticipants, setSelectedParticipants] = useState([]); 

    const toggleParticipant = (selectedParticipant) => {

        console.log('passed selected participant: ', selectedParticipant);

        let alreadySelected = false;

        let newParticipants = selectedParticipants.filter(participant => {

            if(selectedParticipant._id === participant._id){
                alreadySelected = true;

                return false; 
            }

            return participant; 

        }); 

        if(!alreadySelected){

            setSelectedParticipants(prevValue => [...prevValue, selectedParticipant]);
        } else {

            setSelectedParticipants(newParticipants);
        }
    }

    const initChat = (id) => {


        let participants = selectedParticipants.map(participant => participant._id);


        dispatch(startChat(authData.result._id, {
                "participants": [...participants, authData.result._id],
            },
            (err, res) => {

                //grab res room id and send message

                console.log('chat init res: ',res);
            }
        ));

        setCurrentScreen('chatScreen'); 
    }

    const execSearch = (e) => {

        dispatch(searchUsers({search: searchValue}, (err, res)=>{

            console.log('search results', res);

            setSearchResults(res);
        }));
    }
    const newChatScreen = (
        <Box
        
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                overflowY: 'auto'
            }}
        
        >
            <Typography variant='h6' sx={{marginTop: '20px'}}>
                New Message
            </Typography>

            <CustomInput
            
                variant='standard' 
                label="Search Users" 
                sx={{
                    width: '70%'
                }} 
                value={searchValue}
                handleChange={(e)=>setSearchValue(e.target.value)}
                endAdornment={{
                    endAdornment: (
                        <InputAdornment position='end'>

                            <IconButton
                                color='primary'
                                disabled={!searchValue}
                                onClick={execSearch}
                            >

                                <FiSearch style={{
                                    //transform: 'rotate(90deg)'
                                }} />
                                
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />

            <Divider sx={{margin: '10px', width: '80%'}}/>

            {
                selectedParticipants.length > 0 &&

                <>

                    <Typography variant='body1'>
                        Selected:
                    </Typography>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingX: '20px',
                            boxSizing: 'border-box'
                        }}
                    >

                        {selectedParticipants.map((account, index) => {

                                return (
                                    <Box 
                                        key={account.name+index}
                                        sx={{
                                            margin: '10px',
                                            background: theme.palette.faint,
                                            borderRadius: '15px',
                                            padding: '20px',
                                            boxSizing: 'border-box',
                                            width: '100%',
                                            transition: '0.3s',
                                            '&:hover': {
                                                background: theme.palette.lightGray,
                                            },
                                        }}

                                        onClick={e=>toggleParticipant(account)}
                                    >

                                        <UserAvatar imageURL={account.profileImage} name={account.name} bio={account.bio} verified={account.verified} imageSx={{}} nameSx={{}}/>

                                    </Box>
                                )
                            

                            })
                        }

                    </Box>


                    <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                height: '200px',
                                padding: '20px',
                                boxSizing: 'border-box',
                                background: 'white',
                                color: 'white'
                            }}
                    >

                        <Button variant='main' onClick={initChat}> 
                            Message
                        </Button>

                    </Box>


                    <Divider sx={{margin: '10px', width: '80%'}} />

                </>
            }

            


            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingX: '20px',
                    boxSizing: 'border-box'
                }}
            >

                {searchResults.map((account, index) => {

                        return (
                            <Box 
                                key={account.name+index}
                                sx={{
                                    margin: '10px',
                                    background: theme.palette.faint,
                                    borderRadius: '15px',
                                    padding: '20px',
                                    boxSizing: 'border-box',
                                    width: '100%',
                                    transition: '0.3s',
                                    '&:hover': {
                                        background: theme.palette.lightGray,
                                    },
                                }}

                                onClick={e=>toggleParticipant(account)}
                            >

                                <UserAvatar imageURL={account.profileImage} name={account.name} bio={account.bio} verified={account.verified} imageSx={{}} nameSx={{}}/>

                            </Box>
                        )
                    

                    })
                }

            </Box>



        </Box>
    );


    //chatScreen

    const chatScreen = <ChatScreen />;



    const chatScreens = {
        homeScreen,
        newChatScreen,
        chatScreen
    };

    const switchScreen = (newScreen) => {

        if(chatScreens[newScreen]){
            setCurrentScreen(newScreen);
        }
        
    }

    return (

        <>

            <Box
                className='notfications-container'
                sx={{
                    position: 'fixed',
                    top: '0px',
                    left: '0px',
                    zIndex: '1000',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    background: 'white',
                    borderRadius: '0px',
                    maxHeight: '100vh',
                    height: '100vh',
                    overflow: 'hidden',
                    width: '500px',
                    opacity: '1',
                    boxShadow: '0px 9px 11px rgb(0 0 0 / 6%)',
                    [theme.breakpoints.down('sm')] : { 
                        top: '0px',
                        right: '0px',
                        borderRadius: '0px',
                        opacity: '1',
                        width: '100%',
                        maxHeight: '100vh',
                        minHeight: '100vh'
                    }
                }}
            >

                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        maxHeight: '80px',
                        padding: '20px',
                        boxSizing: 'border-box',
                        background: theme.palette.lightGreen,
                        color: 'white'
                    }}
                >

                    <Typography variant='h6'>
                        Messages
                    </Typography>

                    <CloseButton 
                        variant='inverted' 
                        sx={{
                            color: theme.palette.gray
                        }}
                        onClick={closeChat}
                    />

                </Box>


                {
                    chatScreens[currentScreen]
                }

                

            </Box>

        </>        
        
    ); 
}

export default ChatView; 